import { useList, useDetail, useCreate, useUpdate, useDelete, fetchApi } from "@inmagik/react-crud"
import { TipologiaImmagine } from "../types"
import { API_URL } from "../constants"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"
import { useAuth } from "../auth"

export function useTipologieImmaginiList(
  params: // accept also list of ids
  Record<string, string | number | Array<number>> = {},
  enabled = true
) {
  return useList<TipologiaImmagine>(`${API_URL}/admin/tipologie-immagini`, {
    query: params,
    reactQuery: {
      enabled: enabled,
      queryKey: ["tipologie-immagini", params],
    },
  })
}

export function useTipologiaImmagine(id: number | undefined) {
  return useDetail<TipologiaImmagine>(`${API_URL}/admin/tipologie-immagini`, id?.toString())
}

export function useTipologiaImmagineLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/tipologie-immagini/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<TipologiaImmagine>
  }, [])
}

export function useTipologieImmaginiLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/tipologie-immagini?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: TipologiaImmagine[] }>
  }, [])
}

export function useTipologiaImmagineCreate() {
  return useCreate<TipologiaImmagine>(`${API_URL}/admin/tipologie-immagini`)
}

export function useTipologiaImmagineUpdate() {
  return useUpdate<TipologiaImmagine>(`${API_URL}/admin/tipologie-immagini`)
}

export function useTipologiaImmagineDelete() {
  return useDelete(`${API_URL}/admin/tipologie-immagini`)
}
